module.exports = __webpack_public_path__ + "img/upload.5d56a846.svg";